/*!--------------------------------------------------------------------------
// <copyright file="GSS.maintenance.ts" company="Gallup" product="GSS" owner="All">
//    Copyright (c) The Gallup Organization. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------*/
var GSS;
(function (GSS) {
    var maintenance;
    (function (maintenance) {
        jQuery(function ($) {
            // settings
            var $slider = $('.slider'); // class or id of carousel slider
            var $slide = 'li'; // could also use 'img' if you're not using a ul
            var $transition_time = 500; // 0.5 second
            var $time_between_slides = 4000; // 4 seconds
            function slides() {
                return $slider.find($slide);
            }
            slides().fadeOut();
            // set active classes
            var userLang = navigator.language || window.navigator['userLanguage'] || window.navigator['browserLanguage'];
            var hasLanguage = $("#" + userLang).length;
            if (hasLanguage) {
                slides().filter($("#" + userLang)).addClass('active');
                slides().filter($("#" + userLang)).fadeIn($transition_time);
            }
            else {
                slides().filter($("#en-US")).addClass('active');
                slides().filter($("#en-US")).fadeIn($transition_time);
            }
            // auto scroll
            var myVar = setInterval(displayMessage, $transition_time + $time_between_slides);
            function displayMessage() {
                var $i = $slider.find($slide + '.active').index();
                slides().eq($i).removeClass('active');
                slides().eq($i).fadeOut($transition_time);
                if (slides().length == $i + 1)
                    $i = -1; // loop to start
                slides().eq($i + 1).fadeIn($transition_time);
                slides().eq($i + 1).addClass('active');
            }
            ;
            $("#year").text((new Date).getFullYear());
        });
    })(maintenance = GSS.maintenance || (GSS.maintenance = {}));
})(GSS || (GSS = {}));
//# sourceMappingURL=GSS.maintenance.js.map